import {api_smart} from '@/utils/request'
import config from '@/config/index'
// 溯源模板字段管理
export const getTraceFields = (params) => api_smart.request({
  url: 'admin/code/templates/getTraceFields', method: 'get', params
});
export const addTraceField = (data) => api_smart.request({
  url: 'admin/code/templates/addTraceField', method: 'post', data
});
export const saveTraceField = (data) => api_smart.request({
  url: 'admin/code/templates/saveTraceField', method: 'post', data
});
export const deleteTraceField = (data) => api_smart.request({
  url: 'admin/code/templates/deleteTraceField', method: 'delete', data
});
//码批次-列表
export const code_batchs = (params)=>{
  return api_smart.request({
     url: 'admin/code_batchs',
     method: 'get',
     params
   })
};
//码批次
export const codeBatchsOptions = (params)=>{
  return api_smart.request({
     url: 'admin/code_batchs/options',
     method: 'get',
     params
   })
};

////单码-添加
export const singleCodeCreate = (data)=>{
  return api_smart.request({
     url: 'admin/singleCode/store',
     method: 'post',
     data
   })
};
////单码-启用/禁用
export const singleCodeState= (id)=>{
  return api_smart.request({
     url: 'admin/singleCode/state/'+id,
     method: 'post'
   })
};

////单码-删除
export const singleCodeDelete= (id)=>{
  return api_smart.request({
     url: 'admin/singleCode/delete/'+id,
     method: 'DELETE'
   })
};
//单码列表
export const singleCode = (params)=>{
  return api_smart.request({
     url: 'admin/singleCode',
     method: 'get',
     params
   })
};
//可添加禁用码批次
export const codeBatchsSceneOptions = (params)=>{
  return api_smart.request({
     url: 'admin/code_batchs/scene_options',
     method: 'get',
     params
   })
};
//码批次同步
export const codeBatchsSync = (params)=>{
  return api_smart.request({
     url: 'admin/code_batchs/sync',
     method: 'get',
     params
   })
};


//码批次 禁用列表
export const codeBatchsforbids = (params)=>{
  return api_smart.request({
     url: 'admin/forbids',
     method: 'get',
     params
   })
};
//码禁用添加
export const createforbids = (data)=>{
  return api_smart.request({
     url: 'admin/forbids',
     method: 'post',
     data
   })
};
//码禁用详情
export const detailforbids = (params)=>{
  return api_smart.request({
     url: 'admin/forbids/info/'+params.id,
     method: 'get',
     params
   })
};
//码禁用更新
export const editforbids = (data)=>{
  return api_smart.request({
     url: 'admin/forbids/update',
     method: 'post',
     data
   })
};
//码批次 禁用模板下载
export const codeBatchsforbidsTemplate = (params)=>{
  return api_smart.request({
     url: 'admin/forbids/template',
     method: 'get',
     params
   })
};
//码批次 禁用模板导入
export const exportCodeBatchsforbidsTemplate = (data)=>{
  return config.smartUrl[process.env.VUE_APP_type]+'admin/forbids/batch_forbid'
};
//码禁用-启禁用操作
// id ，码批次ID 
export const codeBatchsforbidsStatus = (id,data)=>{
  return api_smart.request({
     url: '/admin/forbids/'+id,
     method: 'PATCH',
     data
   })
};

//码批次 商品赋码
export const code_products = (params)=>{
  return api_smart.request({
     url: 'admin/code_products',
     method: 'get',
     params
   })
};
//码批次 商品赋码添加-获取营销活动范围
export const activitysRangesList = (params)=>{
  return api_smart.request({
     url: 'admin/activitys/ranges/list',
     method: 'get',
     params
   })
};
//码批次 商品赋码添加
export const codeProductsCreate = (data)=>{
  return api_smart.request({
     url: 'admin/code_products',
     method: 'post',
     data
   })
};
//码批次 商品赋码删除
export const codeProductsDel = (id)=>{
  return api_smart.request({
     url: 'admin/code_products/'+id,
     method: 'DELETE'
   })
};

// 扫码明细
export const scan_logs = (params)=>{
  return api_smart.request({
     url: 'admin/scan_logs',
     method: 'get',
     params
   })
};
// 扫码明细-导出
export const scanLogsExport = (params)=>{
  return api_smart.request({
     url: 'admin/scan_logs/export',
     method: 'get',
     params
   })
};
// 扫码明细-详情
export const scan_logs_detail = (id)=>{
  return api_smart.request({
     url: 'admin/scan_logs/'+id,
     method: 'get'
   })
};
// 黑名单列表
export const blacklists = (params)=>{
  return api_smart.request({
     url: 'admin/blacklists',
     method: 'get',
     params
   })
};
// 黑名单记录
export const blacklistsLogs = (params)=>{
  return api_smart.request({
     url: 'admin/blacklists/list',
     method: 'get',
     params
   })
};


//手动添加黑名单
export const createBlacklists = (data)=>{
  return api_smart.request({
     url: 'admin/blacklists',
     method: 'post',
     data
   })
};

//黑名单释放
export const openForbids = (data)=>{
  return api_smart.request({
     url: 'admin/blacklists/forbids',
     method: 'PATCH',
     data
   })
};
//黑名单配置获取
export const blacklistsConfig = ()=>{
  return api_smart.request({
     url: 'admin/blacklists/show_config',
     method: 'get',
     
   })
};
//更新黑名单配置
export const blacklistsUpdateConfig = (data)=>{
  return api_smart.request({
     url: 'admin/blacklists/update_config',
     method: 'post',
     data
   })
};
//防伪提示模板列表
export const antisFakeTem = (params)=>{
  return api_smart.request({
     url: 'admin/antis_fake_tem/index',
     method: 'get',
     params
   })
};
//添加防伪提示模板
export const antisFakeTemCreate = (data)=>{
  return api_smart.request({
     url: 'admin/antis_fake_tem/store',
     method: 'post',
     data
   })
};
//添加防伪提示详情
export const antisFakeTemDetail = (id)=>{
  return api_smart.request({
     url: 'admin/antis_fake_tem/show/'+id,
     method: 'get'
   })
};
//添加防伪提示删除
export const antisFakeTemDel = (id)=>{
  return api_smart.request({
     url: 'admin/antis_fake_tem/delete/'+id,
     method: 'DELETE'
   })
};
//更新防伪提示
export const antisFakeTemUpdate = (id,data)=>{
  return api_smart.request({
     url: 'admin/antis_fake_tem/update/'+id,
     method: 'PUT',
     data
   })
};


//扫码人数
export const scan_logsScanNum = (params)=>{
  return api_smart.request({
     url: 'admin/scan_logs/scanNum',
     method: 'get',
     params
   })
};



// /扫码预警列表
export const code_warning = (params)=>{
  return api_smart.request({
     url: 'admin/code/code_warning/index',
     method: 'get',
     params
   })
};
// /扫码预警-操作记录
export const handle_log = (params)=>{
  return api_smart.request({
     url: 'admin/code/code_warning/handle_log',
     method: 'get',
     params
   })
};

//扫码预警-解除预警
export const relieve_warning_code = (data)=>{
  return api_smart.request({
     url: 'admin/code/code_warning/relieve_warning_code',
     method: 'post',
     data
   })
};
//扫码预警-禁用码
export const forbidden_code = (data)=>{
  return api_smart.request({
     url: 'admin/code/code_warning/forbidden_code',
     method: 'post',
     data
   })
};
// /异常用户预警列表
export const user_code_warning = (params)=>{
  return api_smart.request({
     url: 'admin/code/code_warning/user',
     method: 'get',
     params
   })
};

///异常用户预警-解除预警
export const user_relieve_warning_code = (data)=>{
  return api_smart.request({
     url: 'admin/code/code_warning/user_relieve_warning_code',
     method: 'post',
     data
   })
};
//异常用户预警-拉黑
export const user_forbidden_code = (data)=>{
  return api_smart.request({
     url: 'admin/code/code_warning/user_forbidden_code',
     method: 'post',
     data
   })
};


//单活动开奖-列表
export const singleActList = (params)=>{
  return api_smart.request({
     url: 'admin/code/single_activity/index',
     method: 'get',
     params
   })
};
//单活动开奖--添加
export const singleActAdd = (data)=>{
  return api_smart.request({
     url: 'admin/code/single_activity/add',
     method: 'post',
     data
   })
};

//单活动开奖--删除
export const singleActDel= (data)=>{
  return api_smart.request({
     url: 'admin/code/single_activity/del',
     method: 'DELETE',
     data
   })
};
//单活动开奖--删除
export const singleActStatus= (data)=>{
  return api_smart.request({
     url: 'admin/code/single_activity/set_join_act_page',
     method: 'post',
     data
   })
};
//系统设置-配置详情
export const getCodeConfig = (params)=>{
  return api_smart.request({
     url: 'admin/code/config/info',
     method: 'get',
     params
   })
};
//系统设置-配置更新
export const setCodeConfig = (data)=>{
  return api_smart.request({
     url: 'admin/code/config/update',
     method: 'post',
     data
   })
};
//系统设置-配置更新
export const getFunctionalModule = (params)=>{
  return api_smart.request({
     url: 'admin/code/functionalModule',
     method: 'get',
     params
   })
};

// 物流码扫码模板-是否包含定制模板
export const getIsHaveCustomized = ()=>{
  return api_smart.request({
    url: 'admin/logistics_templates/is_have_customized',
    method: 'get'
  })
};
//物流码扫码模板-定制模板详情
export const getCustomizedTemplate = (params)=>{
  return api_smart.request({
    url: 'admin/logistics_templates/getCustomizedTemplate',
    method: 'get',
    params
  })
};
//物流码扫码模板-模板更新
export const setCustomizedTemplate = (data)=>{
  return api_smart.request({
    url: 'admin/logistics_templates/setCustomizedTemplate',
    method: 'post',
    data
  })
};
//获取手机字段列表
export const getCollectCustomizes = (params)=>{
  return api_smart.request({
    url: 'admin/member_customizes/get_select_list',
    method: 'get',
    params
  })
};
